import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { UIRouter }                from '@uirouter/core';
import { TranslateService }       from '@ngx-translate/core';

import { ApiService }        from '../api/api.service';
import { MessagesService }   from '../messages/messages.service';
import { ProductService }    from './product.service';
import { SessionService }    from '../sessions/session.service';
import { Table }                 from '../table/types/table';
import { TableColumn }       from '../table/types/table-column';
import { TableQueryParameters } from '../table/types/table-query-parameters';
import { TableService }      from '../table/table.service';
import { ProductActionsComponent } from './product.actions.component';

@Component({
  selector   : 'wor-products-list',
  template: require('./products.list.component.html')
})
export class ProductsListComponent implements AfterViewInit, OnInit {
  @Input() products: any;
  @Input() actionsFactory: any;

  filtering: any;
  tableSettings: Table;

  private tableCacheKey = 'products';

  constructor (
    private apiService       : ApiService,
    private messagesService  : MessagesService,
    private productService   : ProductService,
    private router           : UIRouter,
    private sessionService   : SessionService,
    private tableService     : TableService,
    private translateService : TranslateService
  ) {}

  ngOnInit () {
    const company        = this.sessionService.company();
    const actionsFactory = this.actionsFactory || ProductActionsComponent;

    this.filtering = this.tableService.setFiltersFromCache(this.tableCacheKey, {
      inactive_only: false,
      value        : ''
    });

    const columns: TableColumn[] = [
      {
        classes: 'all-caps',
        field  : 'item_code',
        header : { classes: 'all-caps', text: this.translateService.instant('PRODUCT_SPACE.ITEM_CODE') }
      },
      {
        field : 'description',
        header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.DESCRIPTION') }
      },
      {
        field : 'brand',
        header: { text: this.translateService.instant('PRODUCT_SPACE.BRAND') }
      },
      {
        classes: 'text-right',
        field  : 'retail_price',
        header : { classes: 'text-right', text: this.translateService.instant('PRODUCT_SPACE.RETAIL_PRICE') },
        pipe   : 'globalCurrency'
      },
      {
        classes: 'text-right',
        field  : company.price_includes_tax ? 'cost_including_tax' : 'cost',
        header : { classes: 'text-right', text: this.translateService.instant('PRODUCT_SPACE.COST') },
        pipe   : 'globalCurrency'
      },
      {
        classes: 'text-right',
        field  : 'quantity_on_hand',
        header : { classes: 'text-right', text: this.translateService.instant('PRODUCT_SPACE.QTY') }
      }
    ];

    if (company.reserved_stock) {
      columns.push({
        classes: 'text-right',
        field  : 'qty_available',
        header : { classes: 'text-right', text: this.translateService.instant('PRODUCT_SPACE.QTY') }
      });
    }

    columns.push({
      component: {
        bindings: {
          outputs: {
            onActivateClick: event => this.activate(event),
            onEditClick    : event => this.select(event)
          }
        },
        enabled: true,
        factory: actionsFactory
      },
      sortable: false
    });

    this.tableSettings = {
      broadcast: 'filterProducts',
      cache    : { enabled: true, key: this.tableCacheKey },
      columns,
      empty    : { text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_PRODUCTS_FOUND') },
      pagination: {
        enabled   : true,
        pageSize  : this.tableService.getCachedPaging(this.tableCacheKey).pageSize || 10,
        pageSizes : [ 10, 25, 50 ],
        queryCount: () => this.apiService.get('/filters/count', [
          this.filtering.value || '*',
          'products',
          this.filtering.inactive_only
        ])
      },
      rows   : { highlight: { enabled: true } },
      sorting: this.tableService.setSortingFromCache(this.tableCacheKey, {
        direction: 'asc',
        field    : 'item_code'
      })
    };
  }

  ngAfterViewInit (): void {
    const interval = setInterval(() => {
      if (typeof window['filterProducts'] === 'function') {

        clearInterval(interval);

        this.onFiltersChanged();

      }
    }, 100);
  }

  activate ( row : any ) : void {
    this.productService.activate(row)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.PRODUCT_REACTIVATED'), 'success');
      this.router.stateService.reload();
    })
    .catch(err => this.messagesService.error(err));
  }

  getProducts ( params : TableQueryParameters ) : Promise<any> {
    return this.apiService.stream('/filters', [
      this.filtering.value || '*',
      'products',
      params.offset,
      params.pageSize,
      params.field,
      params.direction,
      this.filtering.inactive_only
    ]).then(products => {
      this.products = products;
      return products;
    });
  }

  onFiltersChanged () : void {


    window['filterProducts'](this.filtering);


  }

  select ( event : any ) : void {


    this.router.stateService.go('app.product', { id: event.id || event.row?.id });


    };


  }
